import { render, staticRenderFns } from "./addCollaborators.vue?vue&type=template&id=1c10977b&scoped=true&"
import script from "./addCollaborators.vue?vue&type=script&lang=js&"
export * from "./addCollaborators.vue?vue&type=script&lang=js&"
import style0 from "./addCollaborators.vue?vue&type=style&index=0&id=1c10977b&scoped=true&lang=css&"
import style1 from "./addCollaborators.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c10977b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c10977b')) {
      api.createRecord('1c10977b', component.options)
    } else {
      api.reload('1c10977b', component.options)
    }
    module.hot.accept("./addCollaborators.vue?vue&type=template&id=1c10977b&scoped=true&", function () {
      api.rerender('1c10977b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onboarding/client/collaborator/addCollaborators.vue"
export default component.exports